import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var switchActiveBackground = 'var(--fx_2d2fb1e5_16z4xtn0)';
var switchStyle = 'fx_2d2fb1e5_16z4xtn5';
var switchThumbStyle = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_16z4xtn6',variantClassNames:{size:{xsmall:'fx_2d2fb1e5_16z4xtn7',small:'fx_2d2fb1e5_16z4xtn8','default':'fx_2d2fb1e5_16z4xtn9'}},defaultVariants:{size:'default'},compoundVariants:[]});
var switchVariants = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_16z4xtn1',variantClassNames:{size:{xsmall:'fx_2d2fb1e5_16z4xtn2',small:'fx_2d2fb1e5_16z4xtn3','default':'fx_2d2fb1e5_16z4xtn4'}},defaultVariants:{size:'default'},compoundVariants:[]});

export { switchActiveBackground, switchStyle, switchThumbStyle, switchVariants };
//# sourceMappingURL=switch.vanilla.mjs.map
